import { Badge, BadgeIntent, Size, Tooltip } from '@axieinfinity/matcha'
import { InfoFillIcon } from '@axieinfinity/matcha-icons'

export const BadgeDefaultWallet: React.FC = () => {
  return (
    <Tooltip
      id="default-wallet"
      className="!opacity-100"
      effect="solid"
      target={
        <Badge
          intent={BadgeIntent.Info}
          size={Size.Small}
          text={
            <div className="flex gap-4 items-center">
              <InfoFillIcon />
              <span>Default wallet</span>
            </div>
          }
        />
      }
    >
      <div className="flex gap-12 max-w-[380px]">
        <InfoFillIcon />
        <div className="flex-1 flex flex-col gap-4 text-body-s">
          <div className="text-text-color-default">Default wallet</div>
          <div className="text-text-color-subdued">
            If you have multiple wallets, you can set a wallet to default. This
            default wallet will be used to receive, send and trade in games and
            marketplaces.
          </div>
        </div>
      </div>
    </Tooltip>
  )
}
